<template>
  <card>
    <div class="card-header-custom">
      <button type="submit" class="btn btn-fill btn-primary"
        @click="$router.push('/')"
      >
        <i class="fa fa-plus"></i> Erfassen
      </button>
    </div>
    <div class="row">
      <div class="col-sm-6">
          <label>Zeitraum</label>
        <div class="form-group has-label">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="Bis"
            start-placeholder="Anfangsdatum"
            end-placeholder="Enddatum"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd"
            @change="filterData"
            :picker-options="{ firstDayOfWeek: 1 }"
          />
        </div>
        <product-select v-model="product"
          @input="filterData"
        />
        <div class="row">
          <div class="col-sm-6" v-if="warehouses.length > 1">
              <label>Lager</label>
            <div class="form-group has-label">
              <multiselect v-model="warehouse"
                :options="warehouses"
                track-by="id"
                label="short_name"
                @input="filterData"
              />
            </div>
          </div>
          <div class="col-sm-6">
              <label>Grund</label>
            <div class="form-group has-label">
              <multiselect v-model="cause"
                :options="causes"
                track-by="id"
                label="name"
                @input="filterData"
              />
            </div>
          </div>
        </div>
        <div class="row" v-if="costCenters.length > 1">
          <div class="col-sm-6">
              <label>Kostenstelle</label>
            <div class="form-group has-label">
              <multiselect v-model="costCenter"
                :options="costCenters"
                track-by="id"
                label="name"
                @input="filterData"
              />
            </div>
          </div>
          <div class="col-sm-6">
              <label>Produktkategorien</label>
            <div class="form-group has-label">
              <multiselect v-model="productCategory"
                :options="productCategories"
                track-by="id"
                label="name"
                @input="filterData"
              />
            </div>
          </div>
          <div class="col-sm-6">
              <label>Standort</label>
            <div class="form-group has-label">
              <multiselect v-model="location"
                :options="locations"
                track-by="id"
                label="name"
                @input="filterData"
              />
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <div>
            <fg-input>
              <l-checkbox v-model="accumulated" @input="filterData">Kumuliert</l-checkbox>
            </fg-input>
          </div>
          <el-dropdown trigger="click">
            <button type="submit" class="btn btn-fill btn-info">
              <i class="fa fa-download"></i> Download<i class="el-icon-arrow-down el-icon--right"></i>
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><a class="dropdown-item" :href="downloadUrl">Pdf</a></el-dropdown-item>
              <el-dropdown-item><a class="dropdown-item" :href="`${downloadUrl}&excel=1`">Excel</a></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-sm-12">
        <div style="overflow-x: auto; margin-top: 0.75em;">
        <table class="table table-striped table-bordered">
          <thead>
            <tr v-if="accumulated && stockRotationsSum && stockRotationsSum[0].sum_quantity_in && stockRotationsSum[0].sum_quantity_out">
              <th class="text-right" style="font-size: .9rem; position: relative;"><strong>Summe:</strong></th>
              <th class="text-right" style="font-size: .9rem; position: relative;"><strong>{{ stockRotationsSum[0].sum_quantity }}</strong></th>
              <th class="text-right" style="font-size: .9rem; position: relative;">
                <span class="rotation-in">{{ stockRotationsSum[0].sum_quantity_in }}</span>
              </th>
              <th class="text-right" style="font-size: .9rem; position: relative;">
                <span class="rotation-out">{{ stockRotationsSum[0].sum_quantity_out }}</span>
              </th>
            </tr>
            <tr v-if="!accumulated && stockRotationsSum && stockRotationsSum[0].sum_quantity_in && stockRotationsSum[0].sum_quantity_out">
              <th colspan="2" class="text-right" style="font-size: .9rem; position: relative;"><strong>Summe:</strong></th>
              <th class="text-right" style="font-size: .9rem; position: relative;">
                <div v-show="! cause">
                  <span class="rotation-in">{{ stockRotationsSum[0].sum_quantity_in }}</span><br>
                  <span class="rotation-out">{{ stockRotationsSum[0].sum_quantity_out }}</span>
                  <hr style="margin: 0;">
                </div>
                <strong>{{ stockRotationsSum[0].sum_quantity }}</strong>
              </th>
            </tr>
            <tr>
              <th v-if="! accumulated">Datum</th>
              <th>Produkt</th>
              <th class="text-center">Menge</th>
              <th class="text-center" v-if="! accumulated">Preis</th>
              <th v-if="accumulated">Einbuchungen</th>
              <th v-if="accumulated">Ausbuchungen</th>
              <th v-if="accumulated">EK / STK</th>
              <th v-if="accumulated">EK</th>
              <th v-if="warehouses.length > 1">Lager</th>
              <th v-if="! accumulated">Grund</th>
              <th v-if="! accumulated">User</th>
              <th v-if="! accumulated">Kostenstelle</th>
              <th >Produktkategorie</th>
              <th v-if="! accumulated">&nbsp;</th>
            </tr>
          </thead>
          <transition name="el-fade-in-linear">
            <tbody v-if="! loading">
              <tr is="StockRotationRow"
                v-for="stockRotation in stockRotations"
                :key="stockRotation.id"
                :stock-rotation="stockRotation"
                :accumulated="accumulated"
                :show-warehouse="warehouses.length > 1"
                @deleteStockRotation="deleteStockRotation"
              />
            </tbody>
          </transition>
        </table>
      </div>
      </div>
    </div>
    <l-pagination
      background
      layout="prev, pager, next"
      :per-page="10"
      :page-count="pageCount"
      :value="currentPage"
      @input="changePage"
      @changePerPage="changePerPage"
    />
  </card>
</template>

<script>
import hasPagination from 'src/has-pagination'
import ProductSelect from 'src/components/product-select'
import StockRotationRow from './stock-rotation-row'
import { Collapse, CollapseItem, DatePicker, Dropdown, DropdownItem, DropdownMenu } from 'element-ui'
import api from 'src/api'

export default {
  components: {
    ProductSelect,
    StockRotationRow,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [DatePicker.name]: DatePicker,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  mixins: [hasPagination],
  data () {
    return {
      loading: true,
      stockRotations: [],
      warehouses: [],
      causes: [],
      costCenters: [],
      warehouse: null,
      dateRange: null,
      product: null,
      cause: null,
      costCenter: null,
      accumulated: false,
      api,
      stockRotationsSum: null,
      productCategories: [],
      locations: [],
      productCategory: null,
      location: null,
      totalEinkaufspreis: null
    }
  },
  methods: {
    async deleteStockRotation (stockRotation) {
      if (confirm('Lagerbewegung wirklich löschen?')) {
        await this.initCsrf()

        this.$http.delete(`/stock_rotations/${stockRotation.id}`).then(({ data }) => {
          this.$notify({
            message: `Lagerbewegung erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.stockRotations.findIndex(({ id }) => data.id === id)
          this.stockRotations.splice(index, 1)
          this.getSumData()
        })
      }
    },
    filterData () {
      this.loading = true
      this.changePage(1)
      this.getSumData()
    },
    getCustomQueryData () {
      return {
        date_range: this.dateRange ? encodeURIComponent(this.dateRange) : '',
        product: this.product ? this.product.id : '',
        warehouse: this.warehouse ? this.warehouse.id : '',
        cause: this.cause ? this.cause.id : '',
        cost_center: this.costCenter ? this.costCenter.id : '',
        accumulated: this.accumulated ? 1 : 0,
        product_category: this.productCategory ? this.productCategory.id : '',
        location: this.location ? this.location.id : ''
      }
    },
    getData (query) {
      return this.$http.get(`/stock_rotations?${query}`).then(({ data }) => {
        this.stockRotations = data.data
        console.log(this.stockRotations)
        this.pageCount = data.last_page
        this.loading = false
      })
    },
    // @override
    changePage (page) {
      if (this.currentPage !== page) {
        this.$router.push({ path: 'stock_rotations', query: { page } })
      } else {
        this.fetchTableData()
      }
    },
    getSumData () {
      const query = this.getQuery()
      this.$http.get(`/stock_rotations/sum?${query}`).then(({ data }) => {
        this.stockRotationsSum = data
        console.log(data)
      })
    }
  },
  computed: {
    downloadUrl () {
      return `${api}/stock_rotations/download?${this.getQuery()}`
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'Produkt') {
      this.$store.state.filters.stockRotationsIndex.shouldUse = true
      for (let key in this.$store.state.filters.stockRotationsIndex.query) {
        this.$store.state.filters.stockRotationsIndex.query[key] = this[key]
      }
    } else {
      this.$store.state.filters.stockRotationsIndex.shouldUse = false
    }
    next()
  },
  beforeRouteUpdate (to, from, next) {
    if (to.query && to.query.page) {
      this.currentPage = +to.query.page
      this.fetchTableData().then(() => { next() })
    } else {
      this.currentPage = 1
      this.fetchTableData().then(() => { next() })
    }
  },
  created () {
    const filters = this.$store.state.filters.stockRotationsIndex
    if (filters.shouldUse) {
      for (let [key, value] of Object.entries(filters.query)) {
        this[key] = value
      }
    }
    this.$store.state.filters.stockRotationsIndex.shouldUse = false

    if (this.$route.query && this.$route.query.page) {
      this.currentPage = +this.$route.query.page
    }

    if (this.$route.query['product']) {
      this.$http.get(`/products/${this.$route.query['product']}`).then(({ data }) => {
        this.product = data
        this.fetchTableData()
      })
    } else {
      this.fetchTableData()
    }
    this.$http.get(`/warehouses`).then(({ data }) => {
      this.warehouses = data
    })
    this.$http.get(`/causes`).then(({ data }) => {
      this.causes = data
    })
    this.$http.get(`/cost_centers?order_by=name`).then(({ data }) => {
      this.costCenters = data
    })
    this.$http.get(`/product_categories`).then(({ data }) => {
      this.productCategories = data
    })
    this.$http.get(`/locations`).then(({ data }) => {
      this.locations = data
    })
    this.getSumData()
  }
}
</script>
